import React from 'react';
import { NavLink } from 'react-router-dom';

const ACCENTS = {
    teal:    { pill: 'bg-teal-500/15',    text: 'text-teal-500 dark:text-teal-400',    bar: 'bg-teal-500' },
    indigo:  { pill: 'bg-indigo-500/15',  text: 'text-indigo-500 dark:text-indigo-400', bar: 'bg-indigo-500' },
    emerald: { pill: 'bg-emerald-500/15', text: 'text-emerald-500 dark:text-emerald-400',bar: 'bg-emerald-500' },
    violet:  { pill: 'bg-violet-500/15',  text: 'text-violet-500 dark:text-violet-400', bar: 'bg-violet-500' },
};

const BottomNav = ({ items, accentColor = 'teal' }) => {
    const navItems = items.filter(item => !item.divider && item.action !== 'logout');
    const a = ACCENTS[accentColor] || ACCENTS.teal;

    return (
        <nav
            className="sm:hidden fixed bottom-0 left-0 right-0 w-full z-[80]"
            style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
        >
            {/* Floating frosted glass pill */}
            <div className={`
                mx-4 mb-4 px-2 py-2 rounded-full
                bg-white/80 dark:bg-slate-900/80
                backdrop-blur-xl
                border border-white/20 dark:border-white/5
                shadow-2xl shadow-slate-300/50 dark:shadow-black/60
                flex justify-around items-center
            `}>
                {navItems.map((item, idx) => (
                    <NavLink
                        key={idx}
                        to={item.path}
                        end={item.exact}
                        className={({ isActive }) =>
                            `relative flex flex-col items-center justify-end flex-1 pb-1 pt-2 rounded-[18px] select-none transition-all duration-200 ease-out
                            ${isActive ? a.text : 'text-slate-400 dark:text-slate-500'}`
                        }
                    >
                        {({ isActive }) => (
                            <>
                                {/* Icon wrapper — pill bg when active */}
                                <span className={`flex items-center justify-center w-12 h-8 rounded-full mb-1 transition-all duration-300 ${isActive ? a.pill : ''} ${isActive ? 'shadow-inner' : ''}`}>
                                    <span
                                        className={`w-5 h-5 block transition-transform duration-300 ${isActive ? 'scale-110' : 'scale-90 opacity-60'}`}
                                        dangerouslySetInnerHTML={{ __html: item.icon }}
                                    />
                                </span>

                                {/* Label */}
                                <span className={`text-[9px] font-black tracking-widest uppercase leading-none transition-all duration-300 ${isActive ? 'opacity-100' : 'opacity-0 scale-90 -translate-y-1 absolute bottom-0 pointer-events-none'}`}>
                                    {item.label}
                                </span>
                            </>
                        )}
                    </NavLink>
                ))}
            </div>
        </nav>
    );
};

export default BottomNav;
